import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('Container')(css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    justifyContent: 'center',
    alignItems: 'center',
    gap: ['xs', 'xs', 'xxl'],
    paddingTop: ['xl', 'xxl'],
    paddingBottom: ['l', 'xxl'],
    paddingX: ['m', 'm', 'zero'],
    backgroundColor: 'white',
    width: ['320px', '930px'],
}));
themeStyles.addBaseStyles('LeftColumn')(css({
    flex: ['0 0 0', '0 0 300px'],
    height: ['150px', '350px'],
    width: ['280px', null],
}));
themeStyles.addBaseStyles('RightColumn')(css({
    flex: '1 0 0',
    paddingX: ['30px', '30px', 'zero'],
}));
themeStyles.addBaseStyles('CtaWrapper')(css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    gap: ['m', 'm', 'l'],
    alignItems: 'center',
}));
export default themeStyles;
